import { normalizeURL } from './urls'

export const openLink = async inputURL => {
  let url = normalizeURL(inputURL)

  if (!url) {
    return
  }

  let win = window.open(url)
  win.opener = null
}
